import React from "react";
import Navbar from "./navbar";
import Title from "./title";

export default function Heading(props){
    const username = props.username
    return(
        <div className="heading-container">
            <Title/>
            <Navbar username={username}/>
        </div>
    )
}